import React from "react";
import PropTypes from "prop-types";

const BenefitCard = ({ icon, title, description }) => {
  return (
    <div className="bg-white p-6 rounded-xl shadow-md hover:shadow-lg transition-all duration-300 flex flex-col items-center transform hover:-translate-y-1">
      <div className="rounded-full bg-blue-50 p-4 mb-5 text-blue-600">
        {icon}
      </div>
      <h3 className="font-bold text-xl mb-3 text-center">{title}</h3>
      <p className="text-gray-600 text-center">{description}</p>
    </div>
  );
};

BenefitCard.propTypes = {
  icon: PropTypes.node.isRequired,
  title: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired
};

export default BenefitCard;
